import { useSelector } from 'react-redux';

import { useIsServiceLocalDelivery, getIsServiceLocalDelivery } from './use-is-service-local-delivery';
import Global from '../store/global-selectors';

export const isLocalDeliveryServiceSelectedForFulfillmentPlan = (state, fulfillmentPlanId) => {
  const selectedServiceId = Global.selectEntitiesFulfillmentPlanProperty(state, { fulfillmentPlanId, property: 'serviceId' });
  return getIsServiceLocalDelivery(state, selectedServiceId);
};

export const useIsLocalDeliveryServiceSelectedForFulfillmentPlan = (fulfillmentPlanId) => {
  const selectedServiceId = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId,
      property: 'serviceId',
    }),
  );
  return useIsServiceLocalDelivery(selectedServiceId);
};
